/** Shared animation timing constants. */

/** Durations in milliseconds for timing animations. */
export const DURATION = {
  /** Quick transitions. */
  fast: 200,
  /** Standard transitions. */
  normal: 300,
  /** Slower content reveals. */
  slow: 400,
} as const;

/** Spring configs for motion variants. */
export const SPRING = {
  /** Smooth settle with minimal bounce. */
  gentle: { damping: 20, stiffness: 200 },
  /** Noticeable bounce. */
  bouncy: { damping: 12, stiffness: 180 },
  /** Quick snap with low bounce. */
  snappy: { damping: 18, stiffness: 250 },
} as const;

/** Default delay between items in a staggered entrance sequence (ms). */
export const STAGGER_DELAY = 150;
